export default async function getCoordinates(address) {
    const encodedAddress = encodeURIComponent(address);
    const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodedAddress}`;

    try {
        const response = await fetch(url);
        if (!response.ok) return null;
        const data = await response.json();

        if (data.length === 0) return null;
        return {
            lat: parseFloat(data[0].lat),
            lon: parseFloat(data[0].lon),
        };
    } catch (err) {
        return null;
    }
}